import React, { useState } from 'react';
import Footer from './Footer';

function Login({ apiUrl, onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [nom, setNom] = useState('');
  const [prenom, setPrenom] = useState('');
  const [mode, setMode] = useState('login');
  const [status, setStatus] = useState('');
  const [statusType, setStatusType] = useState('');

  const handleRegister = async () => {
    if (!email || !password || !nom || !prenom) {
      setStatus('Remplis tous les champs !');
      setStatusType('error');
      return;
    }
    try {
      const res = await fetch(`${apiUrl}/auth/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password, nom, prenom })
      });
      const data = await res.json();
      if (res.ok) {
        setStatus(data.message || 'Compte créé !');
        setStatusType('success');
        setMode('login');
      } else {
        setStatus(data.detail || 'Erreur');
        setStatusType('error');
      }
    } catch (err) {
      setStatus('Erreur réseau');
      setStatusType('error');
    }
  };

  const handleLogin = async () => {
    if (!email || !password) {
      setStatus('Remplis tous les champs !');
      setStatusType('error');
      return;
    }
    try {
      const res = await fetch(`${apiUrl}/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
      });
      const data = await res.json();
      if (res.ok && data.token) {
        onLogin(data.token);
      } else {
        setStatus(data.detail || 'Email ou mot de passe incorrect');
        setStatusType('error');
      }
    } catch (err) {
      setStatus('Erreur réseau');
      setStatusType('error');
    }
  };

  return (
    <div className="login-box">
      <div className="login-icon">👤</div>
      <h1>{mode === 'login' ? 'Connexion' : 'Créer un compte'}</h1>
      
      {mode === 'register' && (
        <>
          <input className="input" type="text" placeholder="Nom" value={nom} onChange={(e) => setNom(e.target.value)} /><br/>
          <input className="input" type="text" placeholder="Prénom" value={prenom} onChange={(e) => setPrenom(e.target.value)} /><br/>
        </>
      )}
      
      <input className="input" type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} /><br/>
      <input className="input" type="password" placeholder="Mot de passe" value={password} onChange={(e) => setPassword(e.target.value)} /><br/>
      
      {mode === 'login' ? (
        <div className="bouton_groupe">
          <button className="btn btn-primary" onClick={handleLogin}>Se connecter</button>
          <button className="btn btn-secondary" onClick={() => { setMode('register'); setStatus(''); }}>Créer un compte</button>
        </div>
      ) : (
        <div className="bouton_groupe">
          <button className="btn btn-primary" onClick={handleRegister}>S'inscrire</button>
          <button className="btn btn-secondary" onClick={() => { setMode('login'); setStatus(''); }}>J'ai déjà un compte</button>
        </div>
      )}
      
      <p className={`status ${statusType}`}>{status}</p>
    <Footer />
    </div>
  );
}

export default Login;